import React from 'react';
import { Cloud, CloudOff, Loader2, Save } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Small status indicator for auto-save drafts.
 * Shows: saving spinner, saved checkmark, error icon, or manual save button.
 */
const DraftStatusBadge = ({ status, onManualSave }) => {
  if (status === 'saving') {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-blue-500 animate-pulse">
        <Loader2 className="w-3 h-3 animate-spin" /> Saving draft...
      </span>
    );
  }
  if (status === 'saved') {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-emerald-600">
        <Cloud className="w-3 h-3" /> Draft saved
      </span>
    );
  }
  if (status === 'error') {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs text-red-500">
        <CloudOff className="w-3 h-3" /> Draft save failed
      </span>
    );
  }
  if (onManualSave) {
    return (
      <Button type="button" variant="ghost" size="sm" className="h-7 text-xs text-gray-500 hover:text-blue-600 gap-1"
        onClick={() => onManualSave(true)} data-testid="manual-save-draft">
        <Save className="w-3 h-3" /> Save Draft
      </Button>
    );
  }
  return null;
};

export default DraftStatusBadge;
